import Api from "../../../services/api";
import * as types from "../../types";

/**
 * @copyright 2019 @ DigiNet
 * @author VINHLE
 * @create 2019/01/17 15:37
 * @update 2019/01/17 15:37
 * @file src/actions/user-actions.js
 */

export function loadMaster(param, cb) {
    return (dispatch) => {
        Api.put('/w18f1017/load-store-w17p1041', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadMasterComplete(result.data));
                }
            });
    };
}

function loadMasterComplete(data) {
    return {
        type: types.W18_W18F1017_DATAMASTER_COMPLETE,
        dataMaster: data
    };
}

export function loadGrid(param, cb) {
    return (dispatch) => {
        Api.put('/w18f1017/load-store-w17p1112', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadGridComplete(result.data));
                }
            });
    };
}

function loadGridComplete(data) {
    return {
        type: types.W18_W18F1017_POPUP_COMPLETE,
        dataPopUp: data
    };
}

export function loadWareHouse(param, cb) {
    return (dispatch) => {
        Api.put('/w18f1017/data-by-division-id', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result.data);
                    dispatch(loadWareHouseComplete(result.data));
                }
            });
    };
}

function loadWareHouseComplete(data) {
    return {
        type: types.W18_W18F1017_WAREHOUSE_COMPLETE,
        dataWareHouse: data
    };
}

export function deleteProduct(param, cb) {
    return () => {
        Api.put('/w18f1017/del', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    if (cb) cb(result, null);
                } else {
                    if (cb) cb(null, result);
                }
            });
    };
}
